module.exports = __webpack_public_path__ + "static/img/timeline-plus.b1d15a29.svg";